import { css } from '@emotion/react'

export const grid = css`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(2, 559px);
  margin-top: 24px;
`

export const addButton = css`
  margin-top: 24px;
`
